(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dz-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(header) {
      if (header.dzBound) return;
      header.dzBound = true;

      var burger = header.querySelector('[data-dz-burger]');
      var drawer = header.querySelector('[data-dz-drawer]');
      if (!burger || !drawer) return;

      function setOpen(open) {
        burger.setAttribute('aria-expanded', open ? 'true' : 'false');
        burger.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
        if (open) {
          drawer.removeAttribute('hidden');
        } else {
          drawer.setAttribute('hidden', '');
        }
      }

      burger.addEventListener('click', function () {
        setOpen(burger.getAttribute('aria-expanded') !== 'true');
      });

      /* Close on Escape, returning focus to the button. */
      header.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && burger.getAttribute('aria-expanded') === 'true') {
          setOpen(false);
          burger.focus();
        }
      });

      /* Close after a link is chosen — matters for same-page anchors, where
         no navigation happens to dismiss the drawer. */
      drawer.addEventListener('click', function (event) {
        if (event.target.closest('a')) setOpen(false);
      });
    }

    function boot(scope) {
      var root = scope && scope.querySelectorAll ? scope : document;
      root.querySelectorAll('[data-dz-header]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { boot(); });
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (event) {
      boot(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dz-hero-home"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function respectReducedMotion(scope) {
      if (!window.matchMedia) return;
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      var root = scope && scope.querySelectorAll ? scope : document;
      var videos = root.querySelectorAll('.dz-hero__video');

      for (var i = 0; i < videos.length; i++) {
        var video = videos[i];
        video.removeAttribute('autoplay');
        video.setAttribute('controls', '');
        if (!video.paused) video.pause();

        // Native controls carry their own volume, so hide the custom button
        // to avoid two sets of sound controls on the same video.
        var media = video.closest('.dz-hero__media');
        var sound = media && media.querySelector('.dz-hero__sound');
        if (sound) sound.hidden = true;
      }
    }

    function initSoundToggles(scope) {
      var root = scope && scope.querySelectorAll ? scope : document;
      var buttons = root.querySelectorAll('.dz-hero__sound');

      for (var i = 0; i < buttons.length; i++) {
        (function (btn) {
          if (btn.dataset.dzSoundBound) return;
          btn.dataset.dzSoundBound = '1';

          var media = btn.closest('.dz-hero__media');
          var video = media ? media.querySelector('.dz-hero__video') : null;
          if (!video) { btn.hidden = true; return; }

          function sync() {
            var muted = video.muted || video.volume === 0;
            btn.classList.toggle('is-muted', muted);
            btn.setAttribute(
              'aria-label',
              muted ? btn.dataset.labelUnmute : btn.dataset.labelMute
            );
          }

          btn.addEventListener('click', function () {
            video.muted = !video.muted;
            // Some browsers pause on the first interaction; nudge it back.
            if (!video.muted && video.paused) {
              var p = video.play();
              if (p && p.catch) p.catch(function () {});
            }
            sync();
          });

          // Keep the icon honest if mute state changes from elsewhere.
          video.addEventListener('volumechange', sync);
          sync();
        })(buttons[i]);
      }
    }

    function init(scope) {
      initSoundToggles(scope);
      // Runs after, so a reduced-motion visitor gets native controls and the
      // custom button is hidden rather than left dangling.
      respectReducedMotion(scope);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(); });
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dz-hero-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function respectReducedMotion(scope) {
      if (!window.matchMedia) return;
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      var root = scope && scope.querySelectorAll ? scope : document;
      var videos = root.querySelectorAll('.dz-phero__video');

      for (var i = 0; i < videos.length; i++) {
        var video = videos[i];
        video.removeAttribute('autoplay');
        video.setAttribute('controls', '');
        if (!video.paused) video.pause();
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { respectReducedMotion(); });
    } else {
      respectReducedMotion();
    }

    document.addEventListener('shopify:section:load', function (event) {
      respectReducedMotion(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dz-steps-video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function respectReducedMotion(scope) {
      if (!window.matchMedia) return;
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      var root = scope && scope.querySelectorAll ? scope : document;
      var videos = root.querySelectorAll('.dz-steps__video');

      for (var i = 0; i < videos.length; i++) {
        var video = videos[i];
        video.removeAttribute('autoplay');
        video.setAttribute('controls', '');
        if (!video.paused) video.pause();

        // Native controls carry their own volume, so hide the custom button
        // to avoid two sets of sound controls on the same video.
        var media = video.closest('.dz-steps__media');
        var sound = media && media.querySelector('.dz-steps__sound');
        if (sound) sound.hidden = true;
      }
    }

    function initSoundToggles(scope) {
      var root = scope && scope.querySelectorAll ? scope : document;
      var buttons = root.querySelectorAll('.dz-steps__sound');

      for (var i = 0; i < buttons.length; i++) {
        (function (btn) {
          if (btn.dataset.dzSoundBound) return;
          btn.dataset.dzSoundBound = '1';

          var media = btn.closest('.dz-steps__media');
          var video = media ? media.querySelector('.dz-steps__video') : null;
          if (!video) { btn.hidden = true; return; }

          function sync() {
            var muted = video.muted || video.volume === 0;
            btn.classList.toggle('is-muted', muted);
            btn.setAttribute(
              'aria-label',
              muted ? btn.dataset.labelUnmute : btn.dataset.labelMute
            );
          }

          btn.addEventListener('click', function () {
            video.muted = !video.muted;
            // Some browsers pause on the first interaction; nudge it back.
            if (!video.muted && video.paused) {
              var p = video.play();
              if (p && p.catch) p.catch(function () {});
            }
            sync();
          });

          // Keep the icon honest if mute state changes from elsewhere.
          video.addEventListener('volumechange', sync);
          sync();
        })(buttons[i]);
      }
    }

    function init(scope) {
      initSoundToggles(scope);
      // Runs after, so a reduced-motion visitor gets native controls and the
      // custom button is hidden rather than left dangling.
      respectReducedMotion(scope);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(); });
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
